import * as api from "services/api";
import _ from "lodash";
import history from "../../../../history";

export const EDIT_INN = "[INN EDIT] EDIT_INN";
export const EDIT_INN_SUCCESS = "[INN EDIT] EDIT_INN_SUCCESS";
export const EDIT_INN_FAILED = "[INN EDIT] EDIT_INN_FAILED";

export const GET_INN = "[INN EDIT] GET_INN";
export const GET_INN_SUCCESS = "[INN EDIT] GET_INN_SUCCESS";
export const GET_INN_FAILED = "[INN EDIT] GET_INN_FAILED";

export const SET_VALUE = "[INN EDIT] SET_VALUE";
export const CLEAR_VALUE = "[INN EDIT] CLEAR_VALUE";

export function getInn(id) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_INN
		});

		const { token } = getState().login;

		let response = await api.sendGet("/inn/" + id, {
			Authorization: "Bearer " + token
		});

		if (response.ok) {
			let json = await response.json();

			let order = json.model;
			dispatch({
				type: GET_INN_SUCCESS,
				payload: order
			});
		} else {
			dispatch({ type: GET_INN_FAILED });
		}
	};
}

export function editInn() {
	return async (dispatch, getState) => {
		dispatch({
			type: EDIT_INN
		});

		const { login, innEdit } = getState();

		let { item, clientId, amount, displacement, visitsByMonth } = innEdit;

		const errors = {};

		dispatch(
			setValue({
				errors
			})
		);

		if (_.keys(errors).length > 0) return dispatch({ type: EDIT_INN_FAILED });

		let response = await api.sendPut(
			"/inn/" + item.id,
			{
				...item,
				clientId,
				amount,
				displacement,
				visitsByMonth
			},
			{
				Authorization: "Bearer " + login.token
			}
		);

		if (response.ok) {
			const result = await response.json();

			dispatch({
				type: EDIT_INN_SUCCESS
			});

			dispatch(clearValue());

			history.push("/inns/" + result.model.id);
		} else {
			dispatch({ type: EDIT_INN_FAILED });
		}
	};
}

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function clearValue(force) {
	return {
		type: CLEAR_VALUE,
		payload: force
	};
}
